import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TopHeader from "../components/common/TopHeader";
import HeaderMenu from "../components/common/HeaderMenu";
import MenuBottomBar from "../components/v2/menuBottomMobile";
import { useAppConfig } from "../../appConfig";
import { useUserDetails } from "@/contextApi";
import { getAgentDashboard } from "../../services/agentClientsService";
import { pageURLs } from "@/constants";
import "../styles/bls-dashboard.scss";

const BLSDashboard = () => {
  const navigate = useNavigate();
  const { tenant } = useAppConfig();
  const { userDetails } = useUserDetails();
  const [counts, setCounts] = useState({});

  const firstName =
    userDetails?.firstName || userDetails?.FirstName || "there";
  const tenantBrand = (tenant?.head?.title || "BLS")
    .replace(/\s*[-|]\s*.*$/, "")
    .trim();

  useEffect(() => {
    getAgentDashboard({ isFromMobile: true })
      .then((res) => {
        if (res?.errorCode === 0 && res?.result) setCounts(res.result);
      })
      .catch(() => {});
    document.body.classList.add("bg-offcanvas-fix");
  }, []);

  const goTo = (path) => () => navigate(path);

  return (
    <div className="bls-dashboard">
      <TopHeader
        variant="threeComp"
        outerClassname="bg-white"
        topClassName="w-100 flex-column top-three-custom-pad custom"
        bottomClassName="w-100"
      >
        <HeaderMenu />
      </TopHeader>

      <div className="bls-dashboard__body">
        <div className="bls-dashboard__greeting">
          <p className="bls-dashboard__eyebrow">{tenantBrand}</p>
          <h2>Welcome back, {firstName}.</h2>
          <p className="bls-dashboard__subtitle">
            Here's the real-time buyer demand for your market.
          </p>
        </div>

        <div className="bls-dashboard__stats">
          <button
            type="button"
            className="bls-stat"
            onClick={goTo(pageURLs.agentMyWantAdListings)}
          >
            <span className="bls-stat__count">{counts.wantAd ?? "—"}</span>
            <span className="bls-stat__label">Want-Listings</span>
          </button>
          <button
            type="button"
            className="bls-stat"
            onClick={goTo(pageURLs.agentInventoryListing)}
          >
            <span className="bls-stat__count">{counts.Inventory ?? "—"}</span>
            <span className="bls-stat__label">Inventory</span>
          </button>
          <button
            type="button"
            className="bls-stat"
            onClick={goTo(pageURLs.agentMyClients)}
          >
            <span className="bls-stat__count">{counts.client ?? "—"}</span>
            <span className="bls-stat__label">Clients</span>
          </button>
        </div>

        <button
          type="button"
          className="bls-dashboard__cta"
          onClick={goTo(pageURLs.agentCreatewantadMainScreen)}
        >
          <span className="bls-dashboard__cta-label">Post a Want-Listing</span>
          <span className="bls-dashboard__cta-sub">
            Broadcast your buyer's demand to the network.
          </span>
          <svg
            className="bls-dashboard__cta-arrow"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <line x1="5" y1="12" x2="19" y2="12" />
            <polyline points="12 5 19 12 12 19" />
          </svg>
        </button>

        <div className="bls-dashboard__section">
          <div className="bls-dashboard__section-header">
            <h3>Pending introductions</h3>
            <button
              type="button"
              className="bls-dashboard__link"
              onClick={goTo("/all-introductions")}
            >
              View all
            </button>
          </div>
          <p className="bls-dashboard__empty">
            No introductions waiting on your review.
          </p>
        </div>

        <div className="bls-dashboard__section">
          <div className="bls-dashboard__section-header">
            <h3>Quick links</h3>
          </div>
          <div className="bls-dashboard__quick-links">
            <button
              type="button"
              className="bls-quick-link"
              onClick={goTo(pageURLs.agentMyWantAdListings)}
            >
              <span className="bls-quick-link__label">My Want-Listings</span>
              <span className="bls-quick-link__hint">Manage active posts</span>
            </button>
            <button
              type="button"
              className="bls-quick-link"
              onClick={goTo(pageURLs.agentInventoryListing)}
            >
              <span className="bls-quick-link__label">My Inventory</span>
              <span className="bls-quick-link__hint">Private listings</span>
            </button>
            <button
              type="button"
              className="bls-quick-link"
              onClick={goTo(pageURLs.agentMyClients)}
            >
              <span className="bls-quick-link__label">My Clients</span>
              <span className="bls-quick-link__hint">Buyer roster</span>
            </button>
            <button
              type="button"
              className="bls-quick-link"
              onClick={goTo("/all-introductions")}
            >
              <span className="bls-quick-link__label">Introductions</span>
              <span className="bls-quick-link__hint">Sent and received</span>
            </button>
          </div>
        </div>
      </div>

      <MenuBottomBar
        wrapperClassName="inner-layout-footer-new inner-layout-footer-topfix"
      />
    </div>
  );
};

export default BLSDashboard;
